import { Fragment, type ReactNode } from 'react'

/** Impede quebra de linha no hífen de "e-mail" ("e-" / "mail"). */
export function keepEmailTogether(text: string): ReactNode {
  return text.split(/(e-mail)/gi).map((part, i) =>
    /^e-mail$/i.test(part) ? (
      <span key={i} style={{ whiteSpace: 'nowrap' }}>
        {part}
      </span>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  )
}
